import { render, staticRenderFns } from "./PracticeCourt.vue?vue&type=template&id=2efc647c&"
import script from "./PracticeCourt.vue?vue&type=script&lang=ts&"
export * from "./PracticeCourt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports